import { useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * 页面路由切换时自动滚动到顶部
 */
export default function ScrollToTop() {
  const { pathname } = useLocation()

  useLayoutEffect(() => {
    // 页面路由变化时，滚动到顶部
    // 使用 useLayoutEffect 确保在浏览器绘制前执行
    
    // 滚动 window
    window.scrollTo(0, 0)
    
    // 同时滚动 document 和 body（兼容不同的滚动容器）
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
    
    // 滚动 #app 容器（如果它是滚动容器）
    const appElement = document.getElementById('app')
    if (appElement) {
      appElement.scrollTop = 0
    }
  }, [pathname])

  return null
}
